import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../redux/actions';
import AccountTypeCard from '../../components/AccountTypeCard';
import { getAccountDetails } from '../../businessLogic/AccountsBL';

import { TextBody } from 'web-ui-components/lib/atoms/text';

import { CommonShell } from '../../components/common/CommonShell/CommonShell';
import { getTransactionMethods } from '../../utils/TransactionMethods';
import { checkIsTransactionEnabled, getTransactionAccountData } from '../../businessLogic/AlertsBL';
import AlertTypesCard from '../../components/AlertTypesCard';

export class TransactionAlertsSMELandingPage extends Component {
  constructor(props) {
    super(props);
    this.checkIsIncomingTransactionEnabled = this.checkIsIncomingTransactionEnabled.bind(this);
  }
  checkIsIncomingTransactionEnabled() {
    const { incomingTransactionAlerts } = this.props;
    if (incomingTransactionAlerts) {
      const amountTransactionAlerts = getTransactionAccountData(
        incomingTransactionAlerts,
        'amount'
      );
      return amountTransactionAlerts.enabled;
    }
    return false;
  }
  render() {
    const { accountDetails, content, routeTo, transactionAlerts, transactionAlertMethods } =
      this.props;
    const { transactionAlertsHeader, incomingTransactionsLabel, outgoingTransactionsLabel } =
      content;
    return (
      <CommonShell backClick={() => routeTo('/singlealerts')}>
        <AccountTypeCard accountDetails={accountDetails} />
        <TextBody>
          <p>{transactionAlertsHeader}</p>
        </TextBody>
        <AlertTypesCard
          typeName={incomingTransactionsLabel}
          onAlertTypeChange={() => routeTo('/incomingtransactions')}
          isEnabled={this.checkIsIncomingTransactionEnabled()}
        />
        <AlertTypesCard
          typeName={outgoingTransactionsLabel}
          onAlertTypeChange={() => routeTo('/outgoingtransactions')}
          isEnabled={checkIsTransactionEnabled(transactionAlerts, transactionAlertMethods)}
        />
      </CommonShell>
    );
  }
}

TransactionAlertsSMELandingPage.propTypes = {
  transactionAlerts: PropTypes.string,
  transactionAlertMethods: PropTypes.array,
  routeTo: PropTypes.func,
  accountDetails: PropTypes.shape({}),
  content: PropTypes.shape({}),
  incomingTransactionAlerts: PropTypes.array,
};
const mapStateToProps = (state) => {
  const accountId = state.accountList.get('selectedAccountId');
  return {
    selectedAccountId: accountId,
    accountDetails: getAccountDetails(accountId, state.accountList.get('accountList').accounts),
    transactionAlerts: state.bulkTransactionAlerts.get('bulkTransactionAlerts').debit_alert,
    incomingTransactionAlerts: state.bulkTransactionAlerts.get('incomingTransactionAlerts')
      .credit_alert,
    transactionAlertMethods: getTransactionMethods(
      state.bulkTransactionAlerts.get('bulkTransactionAlerts')
    ),
  };
};
const mapDispatch = (dispatch) => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatch)(TransactionAlertsSMELandingPage);
